import React from "react";
import { useSelector } from "react-redux";
import DeliveryBoxImg from "../../../../assets/icons/delivery-box.svg";
import ProductCard from "../../../ProductCard/ProductCard";
import "../CampaignStep.css";

const CampaignStep2 = ({ products, handleSelectedCard }) => {
  const step2 = useSelector((state) => state.steps.step2Data);

  return (
    <>
      <div className="campaignStep2">
        <ProductCard steps img={DeliveryBoxImg} title="Add new package" body="Create a package and select it" link />
        {products &&
          products.map((data) => {
            return (
              <ProductCard
                key={data.product_id}
                img={data.media ? data.media[0].url : "https://zocket-image-library-output2.s3.amazonaws.com/marketing/Group%2048097025.png"}
                title={data?.name.length > 15 ? data.name.slice(0, 15) + "..." : data.name}
                price={data.currency + " . " + data.selling_price.toLocaleString()}
                body={data.description.length > 68 ? data.description.slice(0, 67).replace(/(<([^>]+)>)/gi, "") + "..." : data.description.replace(/(<([^>]+)>)/gi, "")}
                steps
                data={data}
                step2Data={products}
                step2={step2}
                handleSelectedCard={handleSelectedCard}
              />
            );
          })}
      </div>
    </>
  );
};

export default CampaignStep2;
